__turbopack_context__.v({
  "arrow": "wipes-landing-module__xoE2Yq__arrow",
  "arrowHint": "wipes-landing-module__xoE2Yq__arrowHint",
  "card": "wipes-landing-module__xoE2Yq__card",
  "cta": "wipes-landing-module__xoE2Yq__cta",
  "ctaHint": "wipes-landing-module__xoE2Yq__ctaHint",
  "gallery": "wipes-landing-module__xoE2Yq__gallery",
  "image": "wipes-landing-module__xoE2Yq__image",
  "loaded": "wipes-landing-module__xoE2Yq__loaded",
  "page": "wipes-landing-module__xoE2Yq__page",
  "placeholder": "wipes-landing-module__xoE2Yq__placeholder",
  "section": "wipes-landing-module__xoE2Yq__section",
  "srOnly": "wipes-landing-module__xoE2Yq__srOnly",
});
